import MedicalQuestionnaireSummaryCard from '../components/MedicalQuestionnaireSummaryCard';
import ProfileCard from '../components/ProfileCard';

export default function Profile() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2]">
      <div className="w-full flex flex-col items-center pt-12 md:pt-20 pb-8 md:pb-12 px-4">
        <h1 className="text-[#2B3133] font-libreBaskerville text-[32px] md:text-[44px] leading-[1.1em] mb-6 md:mb-12">
          My Profile
        </h1>
        <MedicalQuestionnaireSummaryCard />
        <ProfileCard />
      </div>
    </div>
  );
}
